<template>
  <div class="navbar rounded-3xl md:px-5"
       :class="{'bg-white':navbarType === 'light','bg-primary':navbarType === 'dark'}">
    <div class="navbar-start w-full">
      <NuxtLink v-if="showBackButton" to="/" class="btn btn-ghost text-xl mr-3">
        <i class="sa sa-arrow-left line2"></i>
      </NuxtLink>
      <div v-else>

      </div>
      <div @click="navigateTo('cerca')">
        <slot name="title"><span class="font-thin text-sm">{{ navbarTitle }}</span></slot>

      </div>
    </div>
    <div class="navbar-center">
    </div>
    <div class="navbar-end">
      <NuxtLink to=/cerca class="btn btn-ghost btn-circle">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
        </svg>
      </NuxtLink>
      <div class="dropdown dropdown-end">
        <div tabindex="0" role="button" class="btn btn-ghost btn-circle">
          <i class="sa sa-hamburger-menu linear"></i>
        </div>
        <ul tabindex="0"
            class="menu menu-sm dropdown-content bg-base-100 rounded-3xl z-[130] mt-3 w-80 p-3 shadow text-secondary">
          <li class="border-b-1 border-secondary">
            <NuxtLink to="/" class="flex content-center"><i class="sa sa-shop bold2"></i><span class="">Market
                solidale</span><i class="sa sa-arrow-right linear ms-auto"></i></NuxtLink>
          </li>
          <li class="border-b-1 border-secondary">
            <NuxtLink to="/about" class="flex content-center"><i class="sa sa-bolt-circle bold2"></i><span
                class="">Chi Siamo</span><i class="sa sa-arrow-right linear ms-auto"></i></NuxtLink>
          </li>
          <li class="border-b-1 border-secondary">
            <NuxtLink to="/come-funziona" class="flex content-center"><i class="sa sa-question-square bold2"></i><span
                class="">Come funziona</span><i class="sa sa-arrow-right linear ms-auto"></i></NuxtLink>
          </li>

          <li class="border-b-1 border-secondary">
            <NuxtLink to="/partecipanti" class="flex content-center"><i
                class="sa sa-verified-check bold2"></i><span class="">Enti Partecipanti</span><i
                class="sa sa-arrow-right linear ms-auto"></i></NuxtLink>
          </li>
          <li class="border-b-1 border-secondary">
            <NuxtLink to="/regalo-solidale" class="flex content-center"><i class="sa sa-gift bold2"></i><span
                class="">Regalo Solidale</span><i class="sa sa-arrow-right linear ms-auto"></i></NuxtLink>
          </li>
          <li class="border-b-1 border-secondary">
            <NuxtLink to="/per-aziende" class="flex content-center"><i class="sa buildings-bold-duotone bold2"></i><span
                class="">Partnership aziendale</span><i class="sa sa-arrow-right linear ms-auto"></i></NuxtLink>
          </li>
          <li>
            <a href="https://italianonprofit.it/iscriviti/?n24=1" target="_blank"
               class="btn btn-block btn-error rounded-full drop-shadow-xl md:btn-wide flex justify-between mx-auto">
              <span>Iscrivi la tua organizzazione</span>
              <i class="sa sa-round-arrow-right-up line2"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">

const navbarTitle = ref("Regali Solidali")
const route = useRoute()
const showBackButton = ref(false)
if (route.path !== '/') {
  showBackButton.value = true
}
/**
 * TODO Logica da rivedere per il cambio di titolo della Navbar
 */
onMounted(() => {
  setTimeout(() => {
    changeNavbarTitle()
  }, 100)
  watch(() => route.path, (value) => {
    showBackButton.value = value !== '/'
    if (route.path.indexOf('record') === -1) {
      setTimeout(() => {
        changeNavbarTitle()
      }, 100)
    }
  }, {deep: true});

});

const changeNavbarTitle = () => {
  if (!document.title.includes('Record') && document.title.includes('|') && document.title.split('|')[0].length) navbarTitle.value = document.title.split('|')[0];
  else navbarTitle.value = 'Regali Solidali';
}

/**
 * Proprietà utilizzate per cambiare la componente in Light o Dark
 */
const props = defineProps(['type'])
const navbarType = ref(props.type)
watch(() => props.type, (value) => {
  navbarType.value = value
}, {deep: true})

/* A cosa serve??
watch(() => props.type, (value) => {
  navbarTitle.value = value
},{deep:true})
*/

</script>

<style lang="scss" scoped>
ul.menu {
  --icon-color: var(secondary);

  li {
    &:not(:last-child) {
      a {
        padding: 0.7rem 0;
        border-bottom: 1px solid #000000;
        border-radius: initial;
      }
    }

    padding: 0.5rem;

    &:last-child {
      a {
        border-bottom: none;
      }
    }

  }
}
</style>